const SEARCH_FORM_ID = 'search';
const SEARCH_FORM_MODAL_ID = 'search_modal';

const SEARCH_FORM_ORDER_INPUT_ID = 'search-order';
const SEARCH_FORM_MODAL_ORDER_INPUT_ID = 'search-order_modal';

const EVENT_SEARCH_EDIT_CLICK = 'search:edit-click';
const EVENT_SEARCH_MODALEDIT_CLICK = 'search_modal:edit-click';

export default {
    SEARCH_FORM_ID,
    SEARCH_FORM_MODAL_ID,
    SEARCH_FORM_ORDER_INPUT_ID,
    SEARCH_FORM_MODAL_ORDER_INPUT_ID,
    EVENT_SEARCH_EDIT_CLICK,
    EVENT_SEARCH_MODALEDIT_CLICK
};
